import React from 'react';
import './Checkmail.css';
import Button from 'react-bootstrap/Button';
import logolight from '../../images/urology-logo-white.svg';
import urologylogotransparent from '../../images/urology-logo-transparent.png';

import emailicon from '../../images/email-icon.svg';
import { Link } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

function CheckmailComponent() {
    return (
      <>
        <section className='chkmail-blk-main'>
            <div className='chkmail-bg-blk'>
                <div className='logo-top'>
                    <img src={urologylogotransparent} alt='logo'></img>
                </div>
            </div>
            <div className='chkmail-text-blk d-flex align-items-center'>
                <div className='chkmail-content'>
                    <div className='mailicon'>
                        <img src={emailicon} alt='key'></img>
                    </div>
                    <div className='chkmail-main-text'>
                        <h2>Check Your Email</h2>
                        <p>We sent a password reset link to john@example.com</p>
                        <Button variant="primary" className='dark-btn reset-btn'>Open Email App</Button>
                        <p>Didn’t receive the email?  <span>Click to resend</span></p>
                    </div>
                    <Link to="/signin" className='backto-blk'><FaArrowLeftLong/>Back to log in</Link>
                </div>
            </div>
        </section>
      </>
    );
}
    
export default CheckmailComponent;